import { RegisterForm } from './RegisterForm';

export const RegisterPage = () => (
  <div className="flex h-full w-full items-center justify-center">
    <div className="bg-white sm:rounded-lg p-7 w-full h-full sm:h-auto sm:w-2/3 xl:w-1/3 flex flex-col justify-between">
      <RegisterForm />
    </div>
  </div>
);
